import React, { useEffect, useRef, useState } from "react";

import { App, Steps } from "antd";
import { createUseStyles } from "react-jss";
import { Row, Col, Container } from "react-bootstrap";
import {  deleteCookie } from "cookies-next";
import UIFrom from "../ui/forms/UIFormNew";
import PendingJobCard from "./PendingJobCard";
import FormSkeleton from "../skeleton/FormSkeleton";
import UIFromHeading from "../ui/forms/UIFromHeading";
import UISuccessMessage from "../ui/common/UISuccessMessage";
import { getFormatedData } from "../../common/FormFormattedData";
import { Button, message as antdMessage } from "antd";

import {
  UIText,
  UIButton,
  UIHeading,
  UINoRecordMessage,
} from "../ui/UIElements";
import {
  postAJob,
  claimACompany,
  createCompany,
  getCreateJobForm,
  getClaimCompanyForm,
  getCreateCompanyForm,
  acceptRejectInvitation,
} from "../../pages/api/Employer/Employer";
import { useRouter } from "next/router";
import { Company } from "../../common/userfuctions";

const { Step } = Steps;
export const AddCompany = ({
  formloding,
  onAddCompany,
  addCompanyfields,
  setStage,
}) => {
  return (
    <>
      {formloding ? (
        <FormSkeleton />
      ) : (
        <div style={{ width: "100%" }}>
          <UIFromHeading
            style={{
              textAlign: "center",
              marginBottom: 50,
            }}
          >
            Add Company
          </UIFromHeading>
          <UIFrom
            fields={addCompanyfields}
            requiredMark={false}
            // buttonLoding={btnLoading}
            size="large"
            onSubmitPress={(a) => {
              onAddCompany(a);
            }}
            onCancelPress={() => setStage && setStage("company")}
          />
        </div>
      )}
    </>
  );
};
const OnBordingModal = ({ steps, getData , employerRoles }) => {
  const styles = useStyles();
  const [progressSteps, setProgressSteps] = useState(0);
  const [addCompanyfields, setAddCompanyFields] = useState([]);
  const [claimCompanyfields, setClaimCompanyfields] = useState([]);
  const [jobPostfields, setJobPostfields] = useState([]);
  const [formloding, setFormloding] = useState(true);
  const [loding, setLoading] = useState(false);
  const [stage, setStage] = useState("company");
  const [successMessage, setSuccessMessage] = useState("");
  const router = useRouter();
  const { message } = App.useApp();
  
 

  const onAddCompanyFormFields = async () => {
    try {
      setFormloding(true);
      const res = await getCreateCompanyForm();
      if (res?.Status === 1) {
        const data = await getFormatedData(res?.Data?.Form);
        setAddCompanyFields(data);
      } else {
        message.error(res?.Error || "Failed to fetch company form");
      }
    } catch (error) {
      console.error("Error fetching company form:", error);
      message.error("Network error: Unable to fetch company form. Please try again.");
    } finally {
      setFormloding(false);
    }
  };

  const onClaimCompanyFormFields = async () => {
    try {
      setFormloding(true);
      const res = await getClaimCompanyForm();
      if (res?.Status === 1) {
        const data = await getFormatedData(res?.Data?.Form);
        setClaimCompanyfields(data);
      } else {
        message.error(res?.Error || "Failed to fetch claim company form");
      }
    } catch (error) {
      console.error("Error fetching claim company form:", error);
      message.error("Network error: Unable to fetch claim company form. Please try again.");
    } finally {
      setFormloding(false);
    }
  };

  useEffect(() => {
   
    if (steps?.InviteMemberStatus == 2) {
      setProgressSteps(11);
      setStage("InvitationAcceptScreen");
      return;
    }
    else if(steps.NoJobHiringManager == 2){
      setProgressSteps(12);
      setStage("noJobHiringManager");

    }
    if (steps?.CompanyStatus == 0) {
      setProgressSteps(0);
    } else if (steps?.CompanyStatus == 2) {
      setProgressSteps(1);
    } else if (steps?.JobStatus == 0) {
      setProgressSteps(2);
      setStage("jobs");
    } else if (steps?.JobStatus == 2) {
      setProgressSteps(2);
      setStage("addMoreJobs");
    }
  }, [steps]);

  const onAddCompany = async (data) => {
    try {
      setLoading(true);
      const res = await createCompany(data);
      if (res?.Status === 1) {
        setSuccessMessage(res?.Message);
        setProgressSteps(1);
      } else {
        message.error(res?.Error || "Failed to create company");
      }
    } catch (error) {
      console.error("Error creating company:", error);
      message.error("Network error: Unable to create company. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onClaimCompany = async (data) => {
    try {
      setLoading(true);
      const res = await claimACompany(data);
      if (res?.Status === 1) {
        setSuccessMessage(res?.Message);
        setProgressSteps(1);
      } else if (res?.Status === 0) {
        message.error(res?.Error || "Failed to claim company");
      }
    } catch (error) {
      console.error("Error claiming company:", error);
      message.error("Network error: Unable to claim company. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getJobPostFields = async () => {
    try {
      setFormloding(true);
      const res = await getCreateJobForm();
      if (res?.Status === 1) {
        const data = await getFormatedData(res?.Data?.Form);
        setJobPostfields(data);
      } else {
        message.error(res?.Error || "Failed to fetch job form");
      }
    } catch (error) {
      console.error("Error fetching job form:", error);
      message.error("Network error: Unable to fetch job form. Please try again.");
    } finally {
      setFormloding(false);
    }
  };

  const onAddJobPost = async (data) => {
    if (data?.JobDescription.replace(/<p><\/p>/g, "") == "") {
      return antdMessage.error("Please add description");
    }

    try {
      setLoading(true);
      const res = await postAJob(data);
      if (res?.Status === 1) {
        message.success(res?.Message);
        await getData();
        window.dispatchEvent(new Event('hireside:job-posted'));
        setStage("addMoreJobs");
      } else {
        message.error(res?.Error || "Failed to post job");
      }
    } catch (error) {
      console.error("Error posting job:", error);
      message.error("Network error: Unable to post job. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const acceptRejectInviation = async (memberid, status) => {
    try {
      setLoading(true);
      const res = await acceptRejectInvitation(memberid, status);
      if (res.Status == 1) {
        message.success(res?.Data?.Message);
        if (status == 3) {
          deleteCookie("companyCode");
        }
        window.location.reload();
      } else {
        message.error(res?.Error || "Failed to process invitation");
      }
    } catch (error) {
      console.error("Error processing invitation:", error);
      message.error("Network error: Unable to process invitation. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const Company = () => {
    return (
      <div style={{ marginTop: 15 }}>
        <UINoRecordMessage
          // Message={"No Company Found"}
          height="20vh"
          textLevel={3}
          width={200}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
          }}
        >
           <UIHeading
            style={{
              fontWidth: 600,
              fontSize: 32,
              margin: 0,
              padding: 0,
            }}
          >
            You are not part of any company
          </UIHeading>
        </div>
      </div>
    );
  };

  const InvitationAcceptScreen = () => {
    return (
      <div>
        <UINoRecordMessage
          Message={
            "You have been invited to join " +
            steps?.CompanyName +
            " Please accept the invitation to continue."
          }
          height="20vh"
          textLevel={3}
          width={200}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <UIButton
            type="secondary"
            onClick={() => {
              acceptRejectInviation(steps?.MemberId, 3);
            }}
          >
            Reject
          </UIButton>

          <UIButton
            onClick={() => {
              acceptRejectInviation(steps?.MemberId, 1);
            }}
            style={{ marginLeft: 10 }}
          >
            Accept
          </UIButton>
        </div>
      </div>
    );
  };

  const ClaimCompany = () => {
    return (
      <>
        {formloding ? (
          <FormSkeleton />
        ) : (
          <div>
            <UIFrom
              fields={claimCompanyfields}
              requiredMark={false}
              buttonLoding={loding}
              size="large"
              onSubmitPress={(a) => {
                onClaimCompany(a);
              }}
              onCancelPress={() => setStage("company")}
            />
          </div>
        )}
      </>
    );
  };

  const Jobs = () => {
    return (
      <>
        <UINoRecordMessage
          Message={employerRoles === 2 ? "No jobs assigned to you yet. " : "Thriving Starts Here! Craft Your Destiny."}
          height="20vh"
          textLevel={3}
          width={200}
        />
        {
       
            employerRoles === 2 ? 
          (null)
          :
          (<div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <UIButton
              onClick={() => {
                setStage("postAJob");
                getJobPostFields();
              }}
              style={{
                textAlign: "center",
                width: "70%",
              }}
            >
              Post a Job
            </UIButton>
          </div>)
          
        }
      </>
    );
  };
  const NoJobHiringManager = () => {
    return (
      <>
        <UINoRecordMessage
          Message={"No jobs assigned to you yet."}
          height="20vh"
          textLevel={3}
          width={200}
        />
        
      </>
    );
  };
  const PostAJob = () => {
     
     
    return (
      <div>
        {formloding ? (
          <FormSkeleton />
        ) : (
          <UIFrom
            fields={jobPostfields}
            requiredMark={true}
            buttonLoding={loding}
            size="large"
            onSubmitPress={(a) => {
              onAddJobPost(a);
            }}
            onCancelPress={() =>
              steps?.JobStatus == 2 ? setStage("addMoreJobs") : setStage("jobs")
            }
          />
        )}
      </div>
    );
  };

  const AddMoreJobs = () => {
    return (
      <div>
        <UINoRecordMessage
          Message={steps?.PendingJobMessage}
          height="20vh"
          textLevel={3}
          width={200}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <UIButton
            type="secondary"
            onClick={() => {
              setStage("pendingJobs");
            }}
          >
            Pending Jobs
          </UIButton>
          <UIButton
            style={{ marginLeft: 8 }}
            onClick={() => {
              setStage("postAJob");
              getJobPostFields();
            }}
          >
            Add More Job
          </UIButton>
        </div>
      </div>
    );
  };

  const PendingJobs = () => {
    return (
      <>
        <Row>
          {steps?.PendingJob?.length > 0 ? (
            steps?.PendingJob?.map((item, index) => {
              return (
                <Col>
                  <PendingJobCard data={item} key={index} />
                </Col>
              );
            })
          ) : (
            <UINoRecordMessage Message={"No Pending Jobs"} />
          )}
        </Row>
      </>
    );
  };

  return (
    <Container>
     {
      steps &&  <div
      style={{
        paddingTop: 100,
        paddingBottom: 100,
        paddingLeft: 250,
        marginRight: 250,
        height: "100%",
        overflow: "auto",
      }}
    >
      {
        
        (progressSteps < 10 && (
          <div style={{ marginBottom: "50px" }}>
            <UIHeading level={2}>HireSide Employer Quick Setup</UIHeading>
            <UIText>
              This Initial Setup will help you kick start your new HireSide
              Employer account.
            </UIText>
          </div>
        ))
        }
      {
        employerRoles === 2 ? 
        (null)
        :
        (progressSteps < 10 && (
          <Steps current={progressSteps} size="small">
            <Step title="Company" />
            <Step title="Verification" />
            <Step title="Jobs" />
          </Steps>
        )) 
      }
      {progressSteps == 11 ? (
        <div style={{ paddingTop: 30 }}>
          {stage == "InvitationAcceptScreen" ? (
            <InvitationAcceptScreen />
          ) : null}
        </div>
      ) : progressSteps == 0 ? (
        <div style={{ paddingTop: 30 }}>
          {stage == "company" ? (
            <Company />
          ) : stage == "addCompany" ? (
            <AddCompany
              formloding={formloding}
              onAddCompany={onAddCompany}
              addCompanyfields={addCompanyfields}
              setStage={setStage}
            />
          ) : stage == "claimCompany" ? (
            <ClaimCompany />
          ) : null}
        </div>
      ) : progressSteps == 1 ? (
        <div style={{ marginTop: 30 }}>
          <UISuccessMessage
            inModal
            message={
              steps?.PendingCompanyMessage
                ? steps?.PendingCompanyMessage
                : successMessage
            }
          />
        </div>
      ) : (
        <div className={styles.jobsdiv}>
          {stage == "jobs" ? (
            <Jobs />
          ) : stage == "postAJob" ? (
            <PostAJob />
          ) : stage == "addMoreJobs" ? (
            <AddMoreJobs />
          ) : stage == "pendingJobs" ? (
            <PendingJobs />
          ) : null}
        </div>
      )
      
      }
       {
       progressSteps === 12 && (
    <div style={{ paddingTop: 30 }}>
      {stage === "noJobHiringManager" ? <NoJobHiringManager/> : null}
    </div>
  )}
    </div>
     }
    </Container>
  );
};

const useStyles = createUseStyles({
  moreBtn: {
    padding: 10,
    background: "#ebf1f7",
    borderRadius: 8,
    cursor: "pointer",
  },
  jobsdiv: {
    marginTop: 40,
    marginBottom: 10,
    margin: 20,
  },
});

export default OnBordingModal;
